import { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import Cookies from "universal-cookie";
import {useServer} from '../context/serverContext';
import { endpoints } from "../env";

const LangContext = createContext(undefined);

export const LangProvider = ({children}) => {
    const { user, checkAuth } = useAuth();
    const { getRequest } = useServer();
    const [lang, setLang] = useState("en");
    const [serverLang, setServerLang] = useState("es");

    useEffect(() => {
        getRequest(endpoints.getServerLang, {}, (res) => {
            if (res[0]) {
                console.log(res[1].lang);
                setServerLang(res[1].lang);
            }
        });
    }, []);

    useEffect(() => {
        if (user !== null) {
            const cookies = new Cookies();
            setLang(user.lang);
        } else {
            setLang(serverLang);
        }
    }, [user, serverLang]);

    const setLangEn = () => {
        getRequest(endpoints.setServerLangEn, {}, (res) => {
            setLang("en");
            setServerLang("en");

            if (user !== null) {
                checkAuth();
            }    
        });
    }

    const setLangEs = () => {
        getRequest(endpoints.setServerLangEs, {}, (res) => {
            setLang("es");
            setServerLang("es");

            if (user !== null) {
                checkAuth();
            }
        });
    }

    const values = {
        lang,
        setLangEn,
        setLangEs
    };

    return (
        <LangContext.Provider
            value={values}
        >
            {children}
        </LangContext.Provider>
    );
};

export const useLang = () => useContext(LangContext);